import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import PrivateRoute from './privateRoute'
import Login from './page/user/login.jsx'
import Home from './page/home'
import Pages from './page/layout.jsx'
import OrgMgr from './page/user/orgMgr.jsx'
import OrgList from './page/user/orgList.jsx'
import UserMgr from './page/user/userMgr.jsx'
import UserList from './page/user/userList.jsx'
import RoleMgr from './page/user/roleMgr.jsx'
import RoleList from './page/user/roleList.jsx';
import PrivilegeMgr from './page/user/privilegeMgr.jsx'
import PrivilegeList from './page/user/privilegeList.jsx';
import MenuList from './page/user/menuList.jsx'
import MenuMgr from './page/user/menuMgr.jsx';
import { Layout } from 'antd'
import 'antd/dist/antd.css'
import '@/asset/css/reset.css'
import '@/asset/font/iconfont.css'

// Import mock util to replace the real Util (using relative path within src)
import { apiUtil as Util, API_CONFIG, getMockLocalStorage } from './mock/mockServices';

// Make our mock Util globally available to replace the original Util
window.Util = Util;
window.API_CONFIG = API_CONFIG;

// Always seed default mock auth credentials on first load so that
// PrivateRoute-protected pages (/train, /predict) work regardless of
// whether real-backend or mock data mode is active. This decouples the
// auth bootstrap (needed for route access) from the data-layer toggle
// (mock vs real). Subsequent loads will find the keys in localStorage
// and skip re-seeding, so the user's saved auth state is respected.
{
  const mockStorage = getMockLocalStorage();
  Object.keys(mockStorage).forEach(key => {
    if (!localStorage.getItem(key)) {
      localStorage.setItem(key, mockStorage[key]);
    }
  });
}

export default class App extends Component {
  render() {
    return (
      <Layout>
        <Router>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/login" exact component={Login} />
            <PrivateRoute path="/orgMgr" exact roles={["admin"]} component={OrgMgr} />
            <PrivateRoute path="/orgList" exact roles={["admin"]} component={OrgList} />
            <PrivateRoute path="/userMgr" exact roles={["admin"]} component={UserMgr} />
            <PrivateRoute path="/userList" exact roles={["admin"]} component={UserList} />
            <PrivateRoute path="/roleMgr" exact roles={["admin"]} component={RoleMgr} />
            <PrivateRoute path="/roleList" exact roles={["admin"]} component={RoleList} />
            <PrivateRoute path="/privilegeMgr" exact roles={["admin"]} component={PrivilegeMgr} />
            <PrivateRoute path="/PrivilegeList" exact roles={["admin"]} component={PrivilegeList} />
            <PrivateRoute path="/menuList" exact roles={["admin"]} component={MenuList} />
            <PrivateRoute path="/menuMgr" exact roles={["admin"]} component={MenuMgr} />
            <Route path="/" component={Pages} />
          </Switch>
        </Router>
      </Layout>
    )
  }
}